export enum ContactTypeValue {
    MOBILE = 117,
    PHONE = 43,
    EMAIL = 47,
    WORK_PHONE_NO = 42,
    HOME_PHONE_NO = 41,
    ALT_PHONE = 46,
    ALT_EMAIL = 48
}



// WEBPACK FOOTER //
// ./src/app/common/enums/contact-type.value.enum.ts